(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('insurance-level', {
                parent: 'entity',
                url: '/insurance-level',
                data: {
                    authorities: [],
                    pageTitle: 'InsuranceLevels'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/insurance-level/list/insurance-level.html',
                        controller: 'InsuranceLevelController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_LEVEL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_LEVEL, access);
                }]
            });
    }
})();
